import { createClient as createSapiClient } from './api/sapiClient'
import { createClient as createDirectClient } from './api/directClient'
import { print, getSpecificPrinter } from './qz/qzTrayService'
import auth from './auth'

const sapiClient = createSapiClient()
const directClient = createDirectClient()

const printShipmentInvoice = async (
	shipmentCp,
	locationKey,
	printerName,
	ciDocumentType
) => {
	let shipmentData = await downloadShipment(shipmentCp, locationKey)
	let documentLink = parseDocumentLink(shipmentData, ciDocumentType)
	let document = await downloadDocument(documentLink)
	await printData(document, printerName)
	return shipmentData
}

const downloadShipment = async (shipmentCp, shipmentLocation) => {
	let result = await sapiClient.get(
		`/v3/shipments?packageRef=${shipmentCp}&locationKey=${shipmentLocation}`,
		{ timeout: 5000 }
	)
	const shipmentsNumber = result.data.shipments.length
	if (shipmentsNumber === 1) {
		return result.data.shipments[0]
	} else if (shipmentsNumber === 0) {
		throw new Error('Shipment ' + shipmentCp + ' does not exist.')
	} else {
		throw new Error('The shipment id ' + shipmentCp + ' is not unique.')
	}
}

const parseDocumentLink = (shipmentData, ciDocumentType) => {
	if (!shipmentData.documents || !shipmentData.documents.length) {
		throw new Error("Shipment doesn't have any documents.")
	}

	const ciDocuments = shipmentData.documents.filter(document =>
		ciDocumentType.test(document.documentTypeKey)
	)
	if (!ciDocuments.length) {
		throw new Error("Shipment doesn't have any CI.")
	}

	const document = ciDocuments[0]
	if (!document.links) {
		throw new Error(
			'Found document ' + document.id + " doesn't have download link."
		)
	}

	return document.links[0].href
}

const downloadDocument = async link => {
	let response = await directClient.get(link, {
		responseType: 'arraybuffer',
		timeout: 5000
	})
	return Buffer.from(response.data, 'binary').toString('base64')
}

const printData = async (data, printerName) => {
	const printer = await getSpecificPrinter(printerName)
	await print([{ data: data, type: 'pdf', format: 'base64' }], printer)
}

const notifySapiAboutPrint = async shipmentId => {
	const metadata = await downloadMetadata(shipmentId)
	const patchedMetadata = patchMedata(metadata)
	await uploadMetadata(shipmentId, patchedMetadata)
}

const downloadMetadata = async shipmentId => {
	let response = await sapiClient.get(`/v3/shipments/${shipmentId}/metadata`, {
		timeout: 5000
	})
	return response.data
}

const patchMedata = metadata => {
	let newMetadata = JSON.parse(JSON.stringify(metadata))
	newMetadata.commercialInvoice.printed = {
		by: auth.getProfile().email,
		at: new Date().toISOString()
	}
	return newMetadata
}

const uploadMetadata = async (shipmentId, metadata) => {
	await sapiClient.patch(`/v3/shipments/${shipmentId}/metadata`, {
		commercialInvoice: metadata.commercialInvoice
	})
}

export { printShipmentInvoice, notifySapiAboutPrint, sapiClient, directClient }



// WEBPACK FOOTER //
// ./src/common/invoiceService.js